import { minimalValidationRules } from './validationRules'
import { getConnectUser } from './getConnectUser'

const isClientInfoValid = (clientData, validationRules) => {
    let isValid = true
    Object.keys(validationRules).forEach((fieldName) => {
        const rules = validationRules[fieldName]
        let fieldError
        rules.some((rule) => {
            fieldError = rule(clientData[fieldName])
            return fieldError !== undefined
        })
        if (fieldError) {
            isValid = false
        }
    })
    return isValid
}

export const isClientInfoComplete = (clientData) => {
    const { country } = getConnectUser()
    const enrollmentValidationRules = minimalValidationRules({
        country
    })
    return isClientInfoValid(clientData, enrollmentValidationRules)
}
